export function getCurrentMonthNumber(): number {
  const currentDate = new Date();
  return currentDate.getMonth() + 1;
}
